export const SET_CHART_METRICS = 'SET_CHART_METRICS';

export const REMOVE_CHART = 'REMOVE_CHART';

export const ADD_CHART = 'ADD_CHART';

export function hourlyTrackerChartsReducer(state, action) {
  switch (action.type) {
    case SET_CHART_METRICS: {
      const { index, value } = action.payload;
      return [
        ...state.slice(0, index),
        { metrics: value },
        ...state.slice(index + 1),
      ];
    }

    case REMOVE_CHART: {
      const { index } = action.payload;
      return [...state.slice(0, index), ...state.slice(index + 1)];
    }

    case ADD_CHART: {
      return [...state, action.payload];
    }

    default:
      return state;
  }
}
